import type { LaborDomain } from "@/lib/labor/laborTarget";

const STORAGE_KEY = "integrator_hub_labor_pending_clock_out_v1";

export interface LaborPendingClockOut {
  sessionId: number;
  domain: LaborDomain;
  recordedAtMs: number;
}

export function writeLaborPendingClockOut(input: { sessionId: number; domain: LaborDomain }): void {
  if (typeof sessionStorage === "undefined") {
    return;
  }
  if (!Number.isFinite(input.sessionId) || input.sessionId <= 0) {
    return;
  }
  const record: LaborPendingClockOut = {
    sessionId: Math.trunc(input.sessionId),
    domain: input.domain,
    recordedAtMs: Date.now(),
  };
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(record));
}

export function readLaborPendingClockOut(): LaborPendingClockOut | null {
  if (typeof sessionStorage === "undefined") {
    return null;
  }
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (raw === null || raw.trim() === "") {
      return null;
    }
    const parsed = JSON.parse(raw) as unknown;
    if (!parsed || typeof parsed !== "object") {
      return null;
    }
    const record = parsed as Record<string, unknown>;
    const sessionId = typeof record.sessionId === "number" ? record.sessionId : Number(record.sessionId);
    const domain = record.domain;
    const recordedAtMs =
      typeof record.recordedAtMs === "number" ? record.recordedAtMs : Number(record.recordedAtMs);
    if (
      !Number.isFinite(sessionId) ||
      sessionId <= 0 ||
      (domain !== "shipping" && domain !== "clampqc" && domain !== "manufacturing") ||
      !Number.isFinite(recordedAtMs)
    ) {
      return null;
    }
    return {
      sessionId: Math.trunc(sessionId),
      domain,
      recordedAtMs: Math.trunc(recordedAtMs),
    };
  } catch {
    return null;
  }
}

export function clearLaborPendingClockOut(): void {
  if (typeof sessionStorage === "undefined") {
    return;
  }
  sessionStorage.removeItem(STORAGE_KEY);
}
